import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.scss'],
})
export class PopUpComponent implements OnInit {
    @Input() isOpen: boolean;
    @Input() titleText: string;
    @Input() bodyText: string;
    @Input() positiveButtonText: string;
    @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter();
    @Output() performAction: EventEmitter<boolean> = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    close() {
        this.isOpenChange.emit(false);
    }

    performPositive() {
        this.performAction.emit(true);
    }
}
